import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';

import { AuthService } from '@services/auth.service';
import { DialogService } from '@services/dialog.service';
import { PartyService } from '@services/party.service';
import { ErrorService } from '@services/error.service';

import { User } from '@models/user';
import { Party } from '@models/party';

import { FORM_COMP_MODES, ROLES } from '@services/constants.service';

@Component({
  selector: 'app-legacy-profile',
  templateUrl: './legacy-profile.component.html',
  styleUrls: ['./legacy-profile.component.scss'],
  standalone: false
})
export class LegacyProfileComponent implements OnInit {
  @Input() currentUser: User | null = null;

  public nameForm: FormGroup;

  public nameError: string = '';
  public showPasswordForm: boolean = false;
  public showNameForm: boolean = false;
  public showEmailForm: boolean = false;
  public adminError: string = '';

  public nameLoading: boolean = false;
  public adminLoading: boolean = false;

  public defaultFormValues: any = {};
  public selectedValue: string = '';
  public partyId: string | null = null;
  public changeRequested: boolean = false;

  public userProps = { employerPartyId: "", employeeRoles: [ROLES.ADMIN] };

  // necessary to reference it in the html template
  public readonly FORM_COMP_MODES = FORM_COMP_MODES;

  constructor(
    private formBuilder: FormBuilder,
    private authService: AuthService,
    private dialogService: DialogService,
    private translateService: TranslateService,
    private partyService: PartyService,
    private errorService: ErrorService,
  ) {
    this.nameForm = this.formBuilder.group({
      firstname: ['',
        Validators.compose([Validators.required])
      ],
      lastname: ['',
        Validators.compose([Validators.required])
      ],
      editing: [false],
    });
  }

  ngOnInit(): void {
    this.authService.getCurrentUser$().subscribe((currentUser: User | null) => {
      if (currentUser) {
        this.nameForm.controls['firstname'].patchValue(currentUser.firstname);
        this.nameForm.controls['lastname'].patchValue(currentUser.lastname);

        this.defaultFormValues = {
          ...currentUser
        }
      }

      // from the settingsPage, the only user to be created is an admin user
      // (admin user identifies by having an EMPLOYMENT relationship to EK Root party)
      this.partyService.getRootParty().then((party: Party | null) => {
        if (party) {
          this.userProps.employerPartyId = party.partyId;
        }
      }).catch((err) => {
        this.errorService.printError(err);
      })
    });
  }

  public togglePasswordForm() {
    this.showPasswordForm = !this.showPasswordForm;
  }

  public toggleNameForm() {
    this.showNameForm = !this.showNameForm;
  }

  public toggleEmailForm() {
    this.showEmailForm = !this.showEmailForm;
  }

  public exitPasswordForm(event: boolean) {
    if (event) {
      this.showPasswordForm = false;
    } else {
      this.dialogService.alert("", this.translateService.instant("Dialog.SettingsComponent.msg_errorWhileSavingPassword"));
    }
  }

  public showForm(form: FormGroup) {
    if (form.controls['editing']) {
      if (form.controls['editing'].value) {
        form.controls['editing'].patchValue(false);

        Object.keys(form.controls).forEach((fieldName: string) => {
          form.controls[fieldName].patchValue(this.defaultFormValues[fieldName] || '');
        })
      } else {
        form.controls['editing'].patchValue(true);
      }
    }
  }

  public exitNameForm(event: boolean) {
    if (event == true) {
      this.showNameForm = false;
      this.dialogService.alert(
        null,
        this.translateService.instant("Name erolgreich geändert."),
        "success"
      );
    }
  }

  public exitEmailForm(event: boolean) {
    if (event == true) {
      this.changeRequested = true;
      this.showEmailForm = false;
      this.dialogService.alert(
        null,
        this.translateService.instant("Email erolgreich geändert."),
        "success"
      );
    } else {
      this.dialogService.alert(
        null,
        this.translateService.instant("Email konnte nicht geändert werden."),
        "danger"
      );
    }
  }

}
